import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Title,
  Text,
  TextInput,
  PasswordInput,
  Button,
  Alert,
  Anchor,
  Stack,
  Center,
  Group,
  Divider,
  Box
} from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useAuth } from '../contexts/AuthContext';
import GoogleSignInButton from '../components/GoogleSignInButton';
import BetaSignupModal from '../components/BetaSignupModal';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showBetaModal, setShowBetaModal] = useState(false);

  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const handleGoogleCredential = async (credential) => {
    setError('');
    setLoading(true);

    const result = await loginWithGoogle(credential);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <>
      <Center style={{ minHeight: '100vh' }}>
        <Container size={420} my={40}>
          <Paper withBorder shadow="md" p={30} radius="md">
            <Title order={2} ta="center" mb={5}>
              Welcome Back
            </Title>
            <Text c="dimmed" size="sm" ta="center" mb={20}>
              Sign in to your GiftPersona account
            </Text>

            <form onSubmit={handleSubmit}>
              <Stack gap="md">
                {error && (
                  <Alert color="red" title="Error">
                    {error}
                  </Alert>
                )}

                <TextInput
                  label="Email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  size="md"
                />

                <PasswordInput
                  label="Password"
                  placeholder="Enter your password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  size="md"
                />

                <Button
                  type="submit"
                  fullWidth
                  size="md"
                  loading={loading}
                  leftSection={<IconLock size={16} />}
                >
                  Sign In
                </Button>
              </Stack>
            </form>

            <Divider my="lg" label="Or" />

            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <GoogleSignInButton
                onCredential={handleGoogleCredential}
                onError={(err) => setError(err.message || 'Google sign-in failed')}
              />
            </Box>

            <Text c="dimmed" size="sm" ta="center" mt={20}>
              Don't have an account?{' '}
              <Anchor
                size="sm"
                style={{ cursor: 'pointer' }}
                onClick={() => setShowBetaModal(true)}
              >
                Sign up here
              </Anchor>
            </Text>
          </Paper>

          {/* Back to Main Button */}
          <Group justify="center" mt="md">
            <Button
              variant="subtle"
              color="grape"
              onClick={() => navigate('/')}
            >
              ← Back to Main
            </Button>
          </Group>
        </Container>
      </Center>

      <BetaSignupModal opened={showBetaModal} onClose={() => setShowBetaModal(false)} />
    </>
  );
};

export default LoginPage;
